import type { ComponentProps, ReactNode } from 'react';

import { Badge as BadgePrimitive, badgeVariants } from '../ui/badge';

export type BadgeProps = Omit<ComponentProps<'span'>, 'children'> & {
  /** Figma "Tone". */
  tone?: 'neutral' | 'brand' | 'success' | 'warning' | 'danger' | 'info';
  /** Figma "Style": Subtle by default; Solid for high-attention counts or statuses. */
  variant?: 'subtle' | 'solid';
  /** Figma "Size": Small 20 (default) · Medium 24. */
  size?: 'sm' | 'md';
  /** Figma "Dot": a 6px status dot before the label. */
  dot?: boolean;
  /** Figma "Label" - short, sentence case. */
  children?: ReactNode;
};

/**
 * Status and metadata label (Figma: Components ↳ Controls ↳ Badge). Not
 * interactive - use a Button for actions.
 */
export function Badge({
  tone = 'neutral',
  variant = 'subtle',
  size = 'sm',
  dot = false,
  children,
  ...props
}: BadgeProps) {
  return (
    <BadgePrimitive tone={tone} variant={variant} size={size} {...props}>
      {dot && (
        <span
          aria-hidden
          data-slot="badge-dot"
          className={badgeVariants({ tone, variant }).dot()}
        />
      )}
      {children}
    </BadgePrimitive>
  );
}
